<template>
    <div id="sidebar-container" class="sidebar-group-outside sidebar-group sidebar-container-margin"
         v-if="sidebarData.length > 0"
         v-bind:class="hasFrame == 'true' ? '' : 'd-none'">
        <sidebar-element
            v-for="element in sidebarData"
            :key="element['id']"
            :element="element"
            />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import SidebarElement from "@/playerVue3/components/sidebar/sidebar-element.vue";

// INITIALIZE STORE & COMPOSABLES
const store = usePlayerStore();

// PROPS
const props = defineProps({
    hasFrame: {
        default: false,
        required: true,
        type: String,
    },
});

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const sidebarData = computed(() => store.getSidebar);

// METHODS

// LYFECYCLE HOOKS
</script>
